import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import { getMpptLenApi, getMpptDataApi } from '@/api';
import { isDateAfterToday } from '@/utils/datetime';

import { mapState } from 'vuex';
import { DateTime } from 'luxon';
import downloadCsv from 'download-csv';
export default {
  name: 'MpptAnalysis',
  computed: _objectSpread({}, mapState(['factoryInfo'])),
  data: function data() {
    return {
      beginDate: DateTime.local().toFormat('yyyy-MM-dd'),
      beginTime: DateTime.local().minus({
        minutes: 1
      }).toFormat('HH:mm'),
      endTime: DateTime.local().toFormat('HH:mm'),
      dateFormat: 'YYYY-MM-DD',
      dateType: 'date',
      dateTypeActive: 'hour',
      irrArr: [],
      invArr: [],
      mpptDataArr: [],
      mpptLenArr: [],
      whichIrr: '',
      contextDataClass: ['voltage', 'current', 'power', 'irr'],
      contextArr: [{
        value: 'voltage',
        text: '電壓 (V)'
      }, {
        value: 'current',
        text: '電流 (A)'
      }, {
        value: 'power',
        text: '功率 (kW)'
      }, {
        value: 'irr',
        text: '日照量 (kWh/m²)'
      }],
      multipleDataArr: [{
        inv: 'INV01',
        mppt: 'MPPT01',
        color: '#f6b73c'
      }, {
        inv: 'INV01',
        mppt: 'MPPT01',
        color: '#1c1c1c'
      }],
      multipleChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading('尚未有資料，請選擇MPPT');
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false
        },
        yAxis: [],
        tooltip: {
          shared: true
        },
        series: [],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      irrMap: []
    };
  },
  methods: {
    isDateAfterToday: isDateAfterToday,
    multipleDataPush: function multipleDataPush() {
      this.multipleDataArr.push({
        inv: 'INV01',
        mppt: 'MPPT01',
        color: '#00458F'
      });
    },
    multipleDataSplice: function multipleDataSplice(idx) {
      this.multipleDataArr.splice(idx, 1);
    },
    filterInvArr: function filterInvArr() {
      var _this = this;
      if (this.whichIrr === '') return this.invArr;
      var irrMap = this.irrMap.map(function (y, yidx) {
        if (y === _this.whichIrr) return yidx;
      }).filter(function (a) {
        return a !== undefined;
      });
      return this.invArr.filter(function (x, idx) {
        return irrMap.includes(idx);
      });
    },
    dedupIrrMap: function dedupIrrMap() {
      return _toConsumableArray(new Set(this.irrMap));
    },
    resetInv: function resetInv() {
      var _this2 = this;
      this.multipleDataArr.forEach(function (x) {
        x.inv = _this2.filterInvArr()[0];
      });
    },
    confirmData: function confirmData() {
      this.multipleDataArr.every(function (x) {
        return Object.values(x).every(function (y) {
          return y !== '';
        });
      }) ? this.getMpptData() : this.$swal('請正確選擇');
    },
    buildChart: function buildChart() {
      var _this3 = this;
      this.multipleChart.xAxis.categories = [];
      this.multipleChart.yAxis = [];
      this.multipleChart.series = [];

      // xAxis.categories
      this.mpptDataArr.forEach(function (x) {
        _this3.multipleChart.xAxis.categories.push(x.time);
      });

      // yAxis
      this.contextDataClass.forEach(function (selectedOption, idx) {
        var yAxisText = _this3.contextArr.find(function (option) {
          return option.value === selectedOption;
        }).text;
        _this3.multipleChart.yAxis.push({
          title: {
            text: "".concat(yAxisText)
          },
          opposite: idx % 2 === 0
        });
      });

      // series obj 電壓 電流 功率
      this.multipleDataArr.forEach(function (data) {
        var selectedOptionRemoveIrr = _this3.contextDataClass.filter(function (item) {
          return item !== 'irr';
        });
        selectedOptionRemoveIrr.forEach(function (selectedOption) {
          var text = _this3.contextArr.find(function (option) {
            return option.value === selectedOption;
          }).text;
          var seriesObj = {
            type: 'line',
            color: data.color === '' ? '#1c1c1c' : data.color,
            name: "".concat(data.inv, "_").concat(data.mppt, "_").concat(text),
            data: [],
            yAxis: _this3.multipleChart.yAxis.findIndex(function (item) {
              return item.title.text === text;
            })
          };
          _this3.multipleChart.series.push(seriesObj);
        });
      });

      // series.data 電壓 電流 功率
      this.mpptDataArr.forEach(function (data) {
        _this3.multipleChart.series.forEach(function (obj) {
          var value = _this3.contextArr.find(function (y) {
            return y.text === obj.name.split('_')[2];
          }).value;
          var inv = _this3.invArr.findIndex(function (y) {
            return y === obj.name.split('_')[0];
          });
          var mppt = _this3.buildMpptOption(obj.name.split('_')[0]).findIndex(function (y) {
            return y === obj.name.split('_')[1];
          });
          obj.data.push(data[value][inv][mppt]);
        });
      });

      // 若有選擇 irr 日照量
      // 需與其他 電壓 電流 等項目 分開計算
      var selectIrr = this.contextDataClass.find(function (selection) {
        return selection === 'irr';
      });
      if (selectIrr) {
        var selectedIrrNo = this.whichIrr === '' ? 0 : this.whichIrr;
        var irrData = this.mpptDataArr.map(function (item) {
          return item.irr[selectedIrrNo];
        });
        this.multipleChart.series.push({
          type: 'line',
          color: '#5B9F23',
          name: "IRR0".concat(selectedIrrNo + 1, "_\u65E5\u7167\u91CF (kWh/m\xB2)"),
          data: irrData,
          yAxis: this.multipleChart.series.length / this.multipleDataArr.length
        });
      }
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.multipleChart.chart.events = {};
        }
      });
    },
    buildMpptOption: function buildMpptOption(inv) {
      var idx = this.invArr.findIndex(function (x) {
        return x === inv;
      });
      return Array.from({
        length: this.mpptLenArr[idx]
      }, function (v, i) {
        return "MPPT".concat(('0' + (i + 1)).slice(-2));
      });
    },
    downloadMpptDataCsv: function downloadMpptDataCsv() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.multipleChart.xAxis.categories);
      this.multipleChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.multipleChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.multipleChart.series.forEach(function (obj, idx) {
        download[idx].data.push(obj.data);
      });
      this.multipleChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, 'MPPT 分析');
    },
    getMpptLen: function getMpptLen() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _mpptLen$data;
        var mpptLen;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getMpptLenApi(_this4.$route.query.siteName);
              case 2:
                mpptLen = _context.sent;
                if (mpptLen !== null && mpptLen !== void 0 && (_mpptLen$data = mpptLen.data) !== null && _mpptLen$data !== void 0 && _mpptLen$data.success) {
                  _this4.mpptLenArr = mpptLen.data.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMpptData: function getMpptData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _mpptData$data;
        var mpptData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getMpptDataApi(_this5.$route.query.siteName, _this5.beginTime, _this5.endTime, _this5.beginDate, _this5.$route.query.fid);
              case 2:
                mpptData = _context2.sent;
                if (mpptData !== null && mpptData !== void 0 && (_mpptData$data = mpptData.data) !== null && _mpptData$data !== void 0 && _mpptData$data.success) {
                  _this5.mpptDataArr = mpptData.data.data;
                  _this5.buildChart();
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  watch: {
    contextDataClass: function contextDataClass(oldValue, newValue) {
      if (oldValue !== newValue && this.mpptDataArr.length !== 0) {
        this.buildChart();
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var factoryInfo;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.getMpptLen();
            case 2:
              _this6.invArr = Array.from({
                length: _this6.$route.query.invLen
              }, function (v, i) {
                return "INV".concat(('0' + (i + 1)).slice(-2));
              });
              factoryInfo = _this6.factoryInfo.find(function (x) {
                return x.factory === _this6.$route.query.siteName;
              });
              _this6.irrMap = factoryInfo.irrMap ? factoryInfo.irrMap : [];
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};